<template>
    <div class="torreairea_torre">

        <div v-if="loadFilters" class="custom__filters-torres" style="">
            <button-back class="custom__filters-torres-back" />
            <Availables class="availables-desk availables-torreairea custom__filters-torres-filter"
                :desarrollo="desarrollo" :type="type" :existFilter="existFilter" :filterPrice="rangeFilterPrice"
                :filterPriceDtos="rangeFilterPrices" @onUpdateModel="updateActiveModel" @defaultDetail="hideDetail" />
        </div>
        <Availables v-if="loadFilters" class="availables-mobile torreairea" :desarrollo="desarrollo" :type="type"
            :existFilter="existFilter" :filterPrice="rangeFilterPrice" :filterPriceDtos="rangeFilterPrices"
            @onUpdateModel="updateActiveModel" @defaultDetail="hideDetail" />

        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torreairea torrespp-design" :class="{ 'show-detail': detailPiso }">
                <h1 class="caption__select">
                    <span>{{ img.name }}</span>
                    <span></span>
                </h1>
                <div class="content__depto">
                    <map-highlight-deptos class="canadas_line" :defaultActive="detailPiso" :indicators="indicators"
                        @activeDetail="showDetailPiso" :torreLevel="levelTorre" :img="img" :existFilter="existFilter"
                        :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />

                    <div class="content-loader detail-piso" v-if="loadElement">
                        <div class="loading__box">
                            <div class="loading show">
                                <div class="spin"></div>
                            </div>
                        </div>
                    </div>
                    <div v-show="detailPiso && !loadElement" class="detail-piso">
                        <Pisos @activeDetailPiso="showDetail" />
                    </div>
                    <div v-show="!detailPiso && !loadElement" class="detail-piso">
                        <h1 class="caption__select ">
                            <span>Seleccione un nivel, clic para ver detalles</span>
                        </h1>
                    </div>
                </div>
                <div class="line_horizontal" v-if="detailPiso"></div>

            </div>
            <div class="select__box torrea" v-show="detailPiso">
                <div v-show="!detail">
                    <h1 class="caption__select torrea">
                        <span>Seleccione un departamento, clic para ver detalles</span>
                    </h1>
                </div>
                <div v-show="detail">
                    <Buttons />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlightDeptos from "../../../core/rediseno/MapHighlightDeptosAirea";
import ButtonBack from "../../../core/ButtonBack";
import Availables from "../../../core/rediseno/Availables.vue";
import Pisos from "./Piso.vue"
import Buttons from "./Model.vue"

export default {
    name: "Main",
    components: {
        MapHighlightDeptos,
        ButtonBack,
        Availables,
        Pisos,
        Buttons
    },
    data() {
        return {
            id: this.$route.params.id,
            levelId: 0,
            //this add
            levelTorre: 35,
            //normal
            type: "departamentos",
            desarrollo: "canadas_deptos",
            arrFilteredLocations: [],
            nivel: "towerStageLevel",
            url: `cve_torre_etapa=${this.$route.params.id}`,
            micrositeUrl: "https://www.tresmarias.com.mx/senderos/terrenos",
            torres: {
                TORRE1: {
                    name: 'TORRE 1',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNueva.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
                },
                TORRE2: {
                    name: 'TORRE 2',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/deptos/fachadaPrincipalNueva.png',
                    width: '3500',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '1969',
                    transform: '',
                    viewBox: '0 0 3500 1969'
                },
            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            rangeFilterPriceT1: [1240000, 1360001],
            rangeFilterPricesT1: {
                'NIVEL 0': [1280000, 1330000, 1340000, 1290000],
                'NIVEL 1': [1320000, 1300000, 1360000, 1350000],
                'NIVEL 2': [1300000, 1280000, 1340000, 1330000],
                'NIVEL 3': [1290000, 1270000, 1330000, 1320000],
                'NIVEL 4': [1260000, 1240000, 1300000, 1290000]
            },
            rangeFilterPriceT2: [1240000, 1360001],
            rangeFilterPricesT2: {
                'NIVEL 0': [1340000, 1330000, 1290000, 1280000],
                'NIVEL 1': [1360000, 1350000, 1320000, 1300000],
                'NIVEL 2': [1340000, 1330000, 1300000, 1280000],
                'NIVEL 3': [1330000, 1320000, 1290000, 1270000],
                'NIVEL 4': [1260000, 1240000, 1290000, 1300000]
            },
            detailPiso: false,
            detail: false,
            indicators: [
                { id: 250, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 251, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 252, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 253, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 254, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
                { id: 255, text: 'PB', transform: 'matrix(1 0 0 1 260 1852)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 0, y1: 0, x2: 0, y2: 0, status: true, class: "indicator_canadas indicator_letter" },
                { id: 256, text: '1', transform: 'matrix(1 0 0 1 300 1622)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1620.62, x2: 780, y2: 1620.62, status: true, class: "indicator_canadas" },
                { id: 257, text: '2', transform: 'matrix(1 0 0 1 300 1342)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1340.62, x2: 780, y2: 1340.62, status: true, class: "indicator_canadas" },
                { id: 258, text: '3', transform: 'matrix(1 0 0 1 300 1050)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 1060.62, x2: 780, y2: 1060.62, status: true, class: "indicator_canadas" },
                { id: 259, text: '4', transform: 'matrix(1 0 0 1 300 772)', cxB: 480.71, cyB: 300.62, rB: 10.29, cxW: 480.71, cyW: 300.62, rW: 5.29, x1: 402, y1: 780.62, x2: 780, y2: 780.62, status: true, class: "indicator_canadas" },
            ],
            //add loading
            loading: false,
            loadFilters: false
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos"
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            const torre = this.$route.params.torre;
            const torreSeleccionada = this.torres[torre];
            return torreSeleccionada;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
        detailM() {
            return this.detail
        },
        loadElement() {
            return this.loading
        },
        rangeFilterPrice() {
            let selectRangeFileter;
            if (this.$route.params.id == 87) {
                selectRangeFileter = this.rangeFilterPriceT1;
            } else if (this.$route.params.id == 88) {
                selectRangeFileter = this.rangeFilterPriceT2;
            } 
            return selectRangeFileter;
        },
        rangeFilterPrices() {
            let selectRangeFileter;
            if (this.$route.params.id == 87) {
                selectRangeFileter = this.rangeFilterPricesT1;
            } else if (this.$route.params.id == 88) {
                selectRangeFileter = this.rangeFilterPricesT2;
            } 
            return selectRangeFileter;
        },
    },
    methods: {
        ...mapActions(["getTowerStageLevels", "clearCoords", "getFilterModelos", "clearDpt"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        showDetailPiso() {
            this.detail = false;
            setTimeout(() => {
                this.loading = true
            }, 100);
            setTimeout(() => {
                this.loading = false
            }, 3000);
            setTimeout(() => {
                this.detailPiso = true;
            }, 3500);
        },
        hideDetailPiso() {
            this.detailPiso = false;
        },
        showDetail() {
            this.detail = true;
        },
        hideDetail() {
            this.detailPiso = false
            this.detail = false;
        },
        loadingFilters() {
            setTimeout(() => {
                this.loadFilters = true
            }, 1000);
        }
    },
    async created() {
        await this.getTowerStageLevels(this.development);
        this.getFilterModelos(this.existFilter)
        this.loadingFilters();
    },
    async beforeDestroy() {
        await this.clearCoords();
        await this.clearDpt();
    },
    mounted() {
        this.detail = false
    }
};
</script>
<style>
.st1.st2.aparece.indicator_canadas {
    font-size: 10rem;
}

.st1.st2.aparece.indicator_canadas.indicator_letter {
    font-size: 8.5rem;
}

.canadas_line .st3.torreai {
    stroke-width: 9;
}
</style>
